import React, { useEffect, useState } from 'react'
import { Widget } from '@typeform/embed-react'
import { useNavigate } from 'react-router'
import { useAppSelector } from '../../store/hooks'
import { selectAuthenticatedUser } from '../../store/auth/authSlice'
import { useIntercom } from 'react-use-intercom'
import { useLazyGetUserHashQuery } from '../../store/user/user'
import { Token } from '../../store/token/token'

const ONBOARDING_CODE_QUERY_PARAM = 'onboarding_code'
const EMAIL_QUERY_PARAM = 'email'
const USER_ID_QUERY_PARAM = 'user_id'
const BD_SOURCE_QUERY_PARAM = 'bd_source'
const ONBOARDING_FORM_ID = import.meta.env.REACT_APP_TYPEFORM_FORM_ID!
const DASHBOARD_URL = import.meta.env.REACT_APP_DASHBOARD_URL!

export const OnboardingView: React.FC = () => {
  const navigate = useNavigate()
  const authenticatedUser = useAppSelector(selectAuthenticatedUser)
  const [booted, setBooted] = useState(false)
  const { boot, hide } = useIntercom()
  const [triggerGetUserHashQuery] = useLazyGetUserHashQuery()

  useEffect(() => {
    const getUserHash = async (accountId: string) => {
      const hash = await triggerGetUserHashQuery({ accountId: accountId })
      return hash
    }

    let ignore = false
    if (!booted && authenticatedUser) {
      getUserHash(authenticatedUser.accountId).then(({ data: userHash }) => {
        if (ignore) {
          return
        }
        boot({
          email: authenticatedUser.email,
          createdAt: authenticatedUser.createdAt,
          userId: authenticatedUser.id,
          userHash,
        })
        hide()
        setBooted(true)
      })
    }
    return () => {
      ignore = true
    }
  }, [authenticatedUser, booted, boot, hide, triggerGetUserHashQuery])

  const onSubmit = () => {
    if (authenticatedUser) {
      const token = Token.fromSerialized(authenticatedUser.token)
      window.location.href = token.tokenUse === 'mfa' ? `${DASHBOARD_URL}/mfa` : `${DASHBOARD_URL}/getting-started/start`
    } else {
      navigate('/wait-list')
    }
  }
  return (
    <Widget
      id={ONBOARDING_FORM_ID}
      fullScreen
      onSubmit={onSubmit}
      transitiveSearchParams={[ONBOARDING_CODE_QUERY_PARAM, EMAIL_QUERY_PARAM, USER_ID_QUERY_PARAM, BD_SOURCE_QUERY_PARAM]}
    />
  )
}
